import { useIntl } from 'react-intl';

import { AnalyticalVariable } from '@verantos-dev/types-cohorts';

import { useAnalyticalVariableCategory } from '../../hooks/useAnalyticalVariableCategory';

export interface HeaderItem {
  label: string;
  value: string;
  icon: 'category' | 'owner' | 'lastModified';
}

export const useAnalyticalVariableCard = ({
  analyticalVariable,
  owner,
  lastModified,
}: {
  analyticalVariable: AnalyticalVariable;
  owner?: string;
  lastModified?: string;
}) => {
  const intl = useIntl();
  const showHeader = owner !== undefined || lastModified !== undefined;
  const { categoryLabel } = useAnalyticalVariableCategory(analyticalVariable);

  const headerItems: HeaderItem[] = showHeader
    ? [
        // Skip the category row entirely when we can't derive a category
        // (SQL-only AVs from the de novo / agent path have no logic tree).
        ...(categoryLabel
          ? [
              {
                label: intl.formatMessage({
                  id: 'projects.analyticalVariables.detailModal.category',
                }),
                value: categoryLabel,
                icon: 'category' as const,
              },
            ]
          : []),
        {
          label: intl.formatMessage({ id: 'projects.analyticalVariables.detailModal.owner' }),
          value: owner ?? '—',
          icon: 'owner',
        },
        {
          label: intl.formatMessage({
            id: 'projects.analyticalVariables.detailModal.lastModified',
          }),
          value: lastModified ?? '—',
          icon: 'lastModified',
        },
      ]
    : [];

  return { showHeader, headerItems };
};
